import {
  isSWSupported,
  closeDesktopNotification as swCloseDesktopNotification,
  showDesktopNotification as swDesktopNotification,
} from '../sw/sw.js'

import { useNotificationsStore } from 'src/stores/notifications.js'

import { mergePopup } from 'src/services/notification_utils/notification_utils_sw.js'

// without a service worker: the pop-up shown per tag, so a new one of the
// same group can name everyone
const state = { failCreateNotif: false, shown: new Map() }

export const showDesktopNotification = (desktopNotificationOpts, i18n) => {
  if (
    !('Notification' in window && window.Notification.permission === 'granted')
  )
    return
  if (useNotificationsStore().desktopNotificationSilence) {
    return
  }

  if (isSWSupported()) {
    swDesktopNotification(desktopNotificationOpts)
  } else if (!state.failCreateNotif) {
    try {
      const { tag } = desktopNotificationOpts
      const popup = mergePopup(
        state.shown.get(tag)?.data,
        desktopNotificationOpts,
        i18n,
      )
      const desktopNotification = new window.Notification(popup.title, popup)
      const entry = { data: popup.data }
      state.shown.set(tag, entry)
      setTimeout(() => {
        // a newer pop-up of the group has taken its place: leave that one
        if (state.shown.get(tag) !== entry) return
        desktopNotification.close()
        state.shown.delete(tag)
      }, 5000)
    } catch {
      state.failCreateNotif = true
    }
  }
}

export const closeDesktopNotification = (id) => {
  if (
    !('Notification' in window && window.Notification.permission === 'granted')
  )
    return

  if (isSWSupported()) {
    swCloseDesktopNotification({ id })
  }
}

export const closeAllDesktopNotifications = () => {
  if (
    !('Notification' in window && window.Notification.permission === 'granted')
  )
    return

  if (isSWSupported()) {
    swCloseDesktopNotification({})
  }
}
